<div fxFlex fxLayout="row" fxLayoutAlign="start start">
  <span>Saving group…</span>
  <span fxFlex></span>
  <mat-spinner diameter="24" color="accent"></mat-spinner>
</div>
